// This icon file is generated automatically.
// tslint:disable
var PlusFunc = { "name": "plus", "theme": "func", "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M576 0v448h448v128H576v448H448V576H0V448h448V0h128z" } }] } };
export default PlusFunc;
